import Promise from 'bluebird';
import axios from 'axios';
import _debug from 'debug';

const debug = _debug('app:http_request');
const makeAxiosRequest = (method, url, headers, data) => (
  new Promise((resolve, reject) => {
    const config = {
      url,
      method,
      headers,
      timeout: 60000000,
      data
    };
    debug('method===>', method);
    debug('Axios url===>', url);
    debug('Axios API called headers', headers);
    debug('Axios API called data', data);
    axios.request(config)
      .then((response) => {
        debug('Axios request successful', response);
        resolve(response);
      })
      .catch((error) => {
        debug('Axios request failed', error);
        reject(error);
      });
  })
);

export default makeAxiosRequest;



// WEBPACK FOOTER //
// ./src/lib/network/httplib/http_request.js